import { utils, writeFileXLSX } from 'xlsx';

export function formatDate(date, format = 'dd/mm/yyyy') {
  const map = {
    mm: date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1,
    dd: date.getDate() < 10 ? `0${date.getDate()}` : date.getDate(),
    yyyy: date.getFullYear(),
  };

  return format.replace(/mm|dd|yyyy/gi, (matched) => map[matched]);
}

export function todayFormatted() {
  const oggi = new Date();
  const format = 'dd/mm/yyyy';
  const formatted = formatDate(oggi, format);

  return formatted;
}

export function today() {
  const oggi = new Date().toISOString();
  return oggi.split('T')[0];
}

export function pescexel(id) {
  const sheet = utils.table_to_sheet(document.getElementById(id));
  const wb = utils.book_new();
  utils.book_append_sheet(wb, sheet, 'Data');
  writeFileXLSX(wb, 'data.xlsx');
}
